import { api } from './base.service';

export const sendShiftChangeRequest = (payload) => {
  return api().post('/api/replacement-shifts/request', payload);
};

export const getShiftChangeRequests = () => {
  return api().get('/api/replacement-shifts');
};

export const getAllShiftChangeRequests = (monthlyScheduleId) => {
  return api().get(`/api/replacement-shifts/all/${monthlyScheduleId}`);
};

export const sendShiftRequestResponse = (payload) => {
  return api().patch('/api/replacement-shifts/response', payload);
};
